// extracted by mini-css-extract-plugin
export default {"wrapper":"JyY33","item":"x4xDD"};